import React from "react";
import styled, { useTheme } from "styled-components";
import { Link } from "react-router-dom";
import { MOBILE_MENU } from "common/constants";
import Tag from "common/Tags/Tag";

interface MenuItemTextProps {
  menuHeader?: boolean;
  clickable?: boolean;
  collapsed: boolean;
  link?: string;
  name: string;
  subName?: string;
  className?: string;
  addNewTag?: boolean;
}

const MenuItemText = ({
  name,
  subName,
  link,
  menuHeader = false,
  collapsed = false,
  clickable = false,
  addNewTag,
  className,
}: MenuItemTextProps) => {
  const theme = useTheme();
  let linkComponent = link ? (
    <StyledLink
      to={link}
      $isHeader={menuHeader}
      className={className}
      $hasSubName={!!subName}
    >
      <span>{name}</span>
      {subName && (
        <span style={{ fontSize: 12 }} className="sub-name">
          {subName}
        </span>
      )}
    </StyledLink>
  ) : (
    <div className={className}>{name}</div>
  );

  const menuId = `menuitem-${name.toLowerCase().replaceAll(" ", "_")}`;

  return (
    <Wrapper
      data-id={menuId}
      $collapsed={collapsed}
      $isTitle={menuHeader}
      $isClickable={clickable}
    >
      {linkComponent}
      {addNewTag && (
        <StyledTag
          style={{
            marginLeft: collapsed ? -8 : 8,
            alignSelf: subName ? "flex-start" : undefined,
            marginTop: subName ? 1 : undefined,
          }}
          color={theme.colors.primaryBlue}
        >
          NEW
        </StyledTag>
      )}
    </Wrapper>
  );
};

export const COLLAPSED_MENU_TITLE_ITEM_HEIGHT = 42;
const FULL_MENU_ITEM_HEIGHT = 30;

const Wrapper = styled.div<{
  $collapsed: boolean;
  $isTitle: boolean;
  $isClickable?: boolean;
}>`
  user-select: none;
  transition: padding 150ms;
  display: flex;
  align-items: center;
  ${(p) =>
    p.$collapsed &&
    `height: ${
      p.$isTitle ? COLLAPSED_MENU_TITLE_ITEM_HEIGHT : FULL_MENU_ITEM_HEIGHT
    }px;
  @media (min-width: calc(${MOBILE_MENU} + 1px)) {
      ${
        p.$isTitle &&
        (p.theme.isDarkMode
          ? "background: rgba(227, 242, 253,0.1);"
          : "background: rgba(225, 245, 254,.25);")
      }
  }

${
  p.$isClickable
    ? `
    cursor: pointer;
    &:hover {
      background: ${p.theme.colors.titleCardBgColor};
    }
`
    : `pointer-events: none;`
}`}
`;
const StyledLink = styled(Link)<{ $isHeader: boolean; $hasSubName?: boolean }>`
  display: flex;
  align-items: center;
  ${(p) =>
    p.$isHeader &&
    `
  font-size: ${p.theme.typography.fontSizes.M};
  font-weight: ${p.theme.typography.fontWeights.NORMAL};
  `}
  ${(p) =>
    p.$hasSubName &&
    `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 42px !important;
    justify-content: space-evenly;
  `};
`;

export const MenuItemTextStyled = styled(MenuItemText)<MenuItemTextProps>`
  padding: 0 ${(p) => (p.collapsed ? 16 : 0)}px;
`;
const StyledTag = styled(Tag)`
  line-height: initial;
  margin-left: 8px;
  font-size: 10px;
  padding: 1px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px !important;
  align-self: center !important;
`;
